// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CreateTagRequestModel from '../../model/create-tag-request-model';
import CreateTagRequestDTO from '../dto/create-tag-request-dto';
import dtoSchema from '../schemas/create-tag-request-schema';

export default abstract class CreateTagRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CreateTagRequestDTO>) {
    super();
    if (data) {
      this.caption = data.caption ?? undefined;
    }
  }
  /**
  */
  caption?: string;

  static toModel(dto: DeepPartial<CreateTagRequestDTO>): CreateTagRequestModel;
  static toModel(dto: DeepPartial<CreateTagRequestDTO> | undefined | null): CreateTagRequestModel | undefined;
  static toModel(dto: DeepPartial<CreateTagRequestDTO> | undefined | null): CreateTagRequestModel | undefined {
    return dto ? new CreateTagRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CreateTagRequestModel> | CreateTagRequestModel): CreateTagRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      caption: unwrapped.caption,
    } as CreateTagRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CreateTagRequestModel, can not map to CreateTagRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
